// @mui material components
import { format } from "date-fns";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

import Card from "@mui/material/Card";
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import TeacherAvatar from "components/TeacherAvatar";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";



import { Link, useParams } from 'react-router-dom';
import { teacherDetailPath } from "utils/teacherRoutes";
import SoftButton from "components/SoftButton";
import PersonOutlined from "@mui/icons-material/PersonOutlined";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { apiurl } from "utils";
import Loading from 'components/Loading';
import api from 'services/api';
import SoftInput from 'components/SoftInput';
import { useFormik } from 'formik';
import { useTranslate } from "utils/i18n";
import { useRegisterAssistantPage } from "assistant/useRegisterAssistantPage";
import { subDays } from "date-fns";
import {
  directoryTableHeaderCellSx,
  directoryTableHeadStickyOverridesSx,
  directoryTableBodyCellDefaultsSx,
} from "assets/theme/designTokens";

function TeacherHistory() {
  const { id } = useParams();
  const [teachers, setTeachers] = useState([]);
  const [teacherData, setTeacherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const { t } = useTranslate();


  // Fetch teachers data from API or any other source
    const fetchTeachers = async (dateData = "",) => {
      setLoading(true);
      try {
        let formattedDate = "";
        if (dateData) {
          const dateObj = new Date(dateData);
          formattedDate = format(dateObj, "yyyy-MM-dd");
        }

        // Prefer a bounded window — full /Teacher/history dump is very slow for long careers.
        const end = formattedDate || format(new Date(), "yyyy-MM-dd");
        const start = formattedDate || format(subDays(new Date(end), 90), "yyyy-MM-dd");

        const res = await api.get(`/Teacher/history`, {
          params: {
            Id: id,
            StartDate: start,
            startDate: start,
            EndDate: end,
            endDate: end,
            pageNumber: 1,
            pageSize: 500,
          },
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("tk446655440000")}`
          }
        });
        const raw = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];
        const filtered = formattedDate
          ? raw.filter((row) => {
              const key = String(row?.attendDateTime ?? row?.AttendDateTime ?? "").slice(0, 10);
              return key === formattedDate;
            })
          : raw;
        setTeachers(filtered);
        setTeacherData(filtered.length > 0 ? filtered[0] : (raw[0] ?? null));
        setPage(1);
        setLoading(false);
      } catch (err) {
        console.error("API Error:", err);
        setLoading(false);
      }
    };

  const formik = useFormik({
    initialValues: {
      date: "",
    },
    // validationSchema: LoginSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      // console.log("Form submitted:", values.date, values.selectschool);
      fetchTeachers(values.date,);
    }
  });


  useEffect(()=>{
    fetchTeachers();
  }, []);

  const assistantPageSnapshot = useMemo(
    () => ({
      pageKey: "teacher-history",
      route: `/histoire-des-enseignants/${id}`,
      selection: teacherData
        ? {
            teacherId: id,
            regNumber: teacherData.regNumber,
            name: [teacherData.name, teacherData.preName].filter(Boolean).join(" "),
          }
        : { teacherId: id },
    }),
    [id, teacherData]
  );
  useRegisterAssistantPage(assistantPageSnapshot);

  // Pagination logic
  const totalPages = Math.ceil(teachers.length / rowsPerPage);
  const startIndex = (page - 1) * rowsPerPage;
  const currentTeachers = teachers.slice(startIndex, startIndex + rowsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };
  function distanceBetweenCoordinates(lat1, lon1, lat2, lon2) {
    const earthRadius = 6371; // km

    const latFrom = (lat1 * Math.PI) / 180;
    const lonFrom = (lon1 * Math.PI) / 180;
    const latTo = (lat2 * Math.PI) / 180;
    const lonTo = (lon2 * Math.PI) / 180;

    const latDelta = latTo - latFrom;
    const lonDelta = lonTo - lonFrom;

    const angle =
      2 *
      Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(latDelta / 2), 2) +
            Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)
        )
      );

    return (angle * earthRadius).toFixed(2); // return distance in km, 2 decimals
  }
  return (
    <DashboardLayout>
      {loading && <Loading />}
      <DashboardNavbar />
        <SoftBox py={3} className="content-area-main">
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} flexWrap="wrap" gap={1}>
              <SoftBox display="flex" alignItems="center" gap={1.5} minWidth={0}>
                <TeacherAvatar teacher={teacherData} size="md" />
                <SoftTypography variant="h6">
                  {t("teacher_history.title", "Histoire")} {teacherData?.name} {teacherData?.preName} - {teacherData?.regNumber}
                </SoftTypography>
              </SoftBox>
              {id ? (
                <SoftButton
                  component={Link}
                  to={teacherDetailPath(id, teacherData?.regNumber) || "#"}
                  variant="gradient"
                  color="info"
                  size="small"
                  startIcon={<PersonOutlined />}
                >
                  {t("teacher_detail.open_profile", "View profile")}
                </SoftButton>
              ) : null}
              <SoftBox component="form" role="form" onSubmit={formik.handleSubmit}>
              {/* <div className="home-date-search">
                    <SoftBox className="date-picker w-40">
                      <SoftBox>
                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                          Sélectionnez la date
                        </SoftTypography>
                      </SoftBox>
                      <SoftInput type="date" placeholder="Entrez votre login" name="date" value={formik.values.date}
                        onChange={formik.handleChange}/>
                    </SoftBox>
                    <SoftButton type="submit" className="map-search" variant="gradient" color="info">
                      Recherche
                    </SoftButton>
                  </div> */}
                  </SoftBox>
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {/* <Table columns={columns} rows={teachers} /> */}
                <Table
                  stickyHeader
                  sx={{
                    minWidth: "100%",
                    ...directoryTableHeadStickyOverridesSx,
                    ...directoryTableBodyCellDefaultsSx,
                  }}
                  aria-label="Liste des enseignants"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.attend_date", "Date de pointage")}</TableCell>
                      {/* <TableCell>{"Matricule de l'enseignant"}</TableCell>
                      <TableCell>{"Nom et prénoms de l'enseignant"}</TableCell>
                      <TableCell>{"Sexe de l'enseignant"}</TableCell> */}
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.status", "Statut de l'enseignant")}</TableCell>
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.degree", "Diplôme de l'enseignant")}</TableCell>
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.est_coords", "Coordonnées de l'établissement")}</TableCell>
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.att_coords", "Coordonnées du pointage")}</TableCell>
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.distance", "Distance")}</TableCell>
                      <TableCell sx={directoryTableHeaderCellSx}>{t("home.table.imei", "IMEI du téléphone")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {currentTeachers.map((row) => (
                      <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell>{row.attendDateTime.replace("T", " ")}</TableCell>
                        {/* <TableCell>{row.regNumber}</TableCell>
                        <TableCell>{row.name + ' ' + row.preName}</TableCell>
                        <TableCell>{row.gender}</TableCell> */}
                        <TableCell>{row.status}</TableCell>
                        <TableCell>{row.degree}</TableCell>
                        <TableCell>
                          {row.estLatitude + " " + row.estLongitude}<br />
                          ({row.estName})
                        </TableCell>
                        <TableCell>
                          <Link 
                            to={`/map`} 
                            state={{ row }} 
                            onClick={() => 
                            localStorage.setItem("mapData", JSON.stringify(row))} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{color: '#17c1e8'}}
                          >
                            {row.attLatitude + " " + row.attLongitude}
                          </Link>
                        </TableCell>
                        <TableCell>
                           {distanceBetweenCoordinates(
                              row.estLatitude,
                              row.estLongitude,
                              row.attLatitude,
                              row.attLongitude
                            )}{" "}
                            km
                        </TableCell>
                        <TableCell>{row.imei}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
               <Stack spacing={2}>
                <div className="pagination-main">
                <Pagination count={totalPages}
                  page={page}
                  onChange={handlePageChange} 
                  color="primary" 
                />
                </div>
              </Stack>
            </SoftBox>
          </Card>
        </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TeacherHistory;
